module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headerloi01",
      "epub:type": "frontmatter",
      "id": "loi"
    }
  }, [_c('header', {
    attrs: {
      "id": "headerloi01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "ix",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0007#rloi"
    }
  }, [_vm._v("Illustrations")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0001#cvi"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("Cover.")]), _vm._v(" "), _c('i', [_vm._v("Our Heavenly Mother")]), _vm._v(", 2020, illustration by Lindsay van Ekelenburg")]), _vm._v(" ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.lindsayvanek.com",
      "target": "_blank"
    }
  }, [_vm._v("www.lindsayvanek.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0101"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0010#fig0101"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("1.1.")]), _vm._v(" "), _c('i', [_vm._v("Blessed Rebel Queen")]), _vm._v(", 2017, by Lindsay van Ekelenburg")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0102"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0010#fig0102"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("1.2.")]), _vm._v(" Still from "), _c('i', [_vm._v("Looking for Leia")]), _vm._v(", Dir. Annalise Ophelian (2019; What Do We Want Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0103"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0010#fig0103"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("1.3.")]), _vm._v(" "), _c('i', [_vm._v("Obi-Wan Kenobi—Wishful Drinking Carrie Fisher")]), _vm._v(" by Shannon Kringen is licensed with CC BY 2.0.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0104"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0010#fig0104"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("1.4.")]), _vm._v(" "), _c('i', [_vm._v("Carrie Fisher Star Memorial Hollywood Walk of Fame")]), _vm._v(" by Justin Sewell is licensed with CC BY 2.0.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0201"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0012#fig0201"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("2.1.")]), _vm._v(" "), _c('i', [_vm._v("Pink Leia")]), _vm._v(", 2020, from Mary’s ever-growing “Leia Land”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0202"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0012#fig0202"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("2.2.")]), _vm._v(" "), _c('i', [_vm._v("We Are the Resistance")]), _vm._v(" poster art, 2017, by Vanessa Witter")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0203"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0012#fig0203"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("2.3.")]), _vm._v(" Personal photo, 2017, by Julie Smith")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0301"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0013#fig0301"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("3.1.")]), _vm._v(" Still from "), _c('i', [_vm._v("Looking for Leia")]), _vm._v(", Dir. Annalise Ophelian (2019; What Do We Want Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0302"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0013#fig0302"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("3.2.")]), _vm._v(" "), _c('i', [_vm._v("Leia Pink Bespin")]), _vm._v(", 2020, from Mary’s ever-growing “Leia Land”")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0303"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0013#fig0303"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("3.3.")]), _vm._v(" "), _c('i', [_vm._v("I Grew Up Star Wars")]), _vm._v(" page design, 2020, Brandon Berges; “Church Halloween Festival” photo, 1982, by Jake Stevens")]), _vm._v(" ("), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.From4-LOMtoZuckuss.com",
      "target": "_blank"
    }
  }, [_vm._v("www.From4-LOMtoZuckuss.com")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0401"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0014#fig0401"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("4.1.")]), _vm._v(" Still from "), _c('i', [_vm._v("Rogue One")]), _vm._v(" (2016; Lucasfilm Ltd.)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0402"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0014#fig0402"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("4.2.")]), _vm._v(" Two stills from "), _c('i', [_vm._v("The Congress")]), _vm._v(" (2013; Pandora Filmproduktion)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0501"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0501"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.1.")]), _vm._v(" "), _c('i', [_vm._v("Resist")]), _vm._v(", 2017, by Hayley Gilmore")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0502"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0502"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.2.")]), _vm._v(" Personal photo, 2018, by Anthony Breznican")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0503"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0503"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.3a.")]), _vm._v(" "), _c('i', [_vm._v("Uncle Sam")]), _vm._v(", 1917, by J. M. Flagg")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0503"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.3b.")]), _vm._v(" "), _c('i', [_vm._v("Don’t Be Silent Now")]), _vm._v(", 2017")]), _vm._v(", by "), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.GregHornArt.com",
      "target": "_blank"
    }
  }, [_vm._v("GregHornArt.com")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0504"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0504"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.4a.")]), _vm._v(" "), _c('i', [_vm._v("Rosie the Riveter")]), _vm._v(", 1942, by J. Howard Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0504"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.4b.")]), _vm._v(" "), _c('i', [_vm._v("Leia the Riveter")]), _vm._v(" poster, n.d., artist unknown")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0505"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0505"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.5a.")]), _vm._v(" "), _c('i', [_vm._v("Hope")]), _vm._v(", 2008, by Shepard Fairey")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill"
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0505"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.5b.")]), _vm._v(" Personal photo, 2017, by Alexa Bourdage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0506"
    }
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "x",
      "id": "px",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0015#fig0506"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("5.6.")]), _vm._v(" Personal photo, 2017, by @MaraJade_2017 in Providence, Rhode Island")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0601"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0017#fig0601"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("6.1.")]), _vm._v(" "), _c('i', [_vm._v("Carrie Fisher")]), _vm._v(" in Wishful Drinking, 2010, AF archive / Alamy Stock Photo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0602"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0017#fig0602"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("6.2.")]), _vm._v(" Debbie Reynolds and Eddie Fisher with Carrie, February 6, 1956, © 2000 Globe Photos / ZUMA Press, Inc. / Alamy Stock Photo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0701"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0018#fig0701"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("7.1.")]), _vm._v(" Two stills from "), _c('i', [_vm._v("These Old Broads")]), _vm._v(" (2001; Sony Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0702"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0018#fig0702"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("7.2.")]), _vm._v(" Two stills from "), _c('i', [_vm._v("Valley of the Dolls")]), _vm._v(" (1967; Twentieth Century Fox)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0703"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0018#fig0703"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("7.3.")]), _vm._v(" Two stills from "), _c('i', [_vm._v("These Old Broads")]), _vm._v(" (2001; Sony Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0704"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0018#fig0704"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("7.4.")]), _vm._v(" Two stills from "), _c('i', [_vm._v("These Old Broads")]), _vm._v(" (2001; Sony Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0801"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0019#fig0801"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("8.1.")]), _vm._v(" Still from "), _c('i', [_vm._v("The Late Show with Stephen Colbert")]), _vm._v(" (November 22, 2016; CBS)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0802"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0019#fig0802"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("8.2.")]), _vm._v(" Still from "), _c('i', [_vm._v("Bright Lights")]), _vm._v(" (2017; Bloomfish Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0803"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0019#fig0803"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("8.3.")]), _vm._v(" Still from "), _c('i', [_vm._v("Bright Lights")]), _vm._v(" (2017; Bloomfish Pictures)")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0901"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0020#fig0901"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("9.1.")]), _vm._v(" Carrie Fisher in "), _c('i', [_vm._v("Wishful Drinking")]), _vm._v(", (2010) AF Archive / Alamy Stock Photo")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0902"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0020#fig0902"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("9.2.")]), _vm._v(" Image adapted from “Carrie Fisher” from San Diego Comic Con, 2012, by Gage Skidmore is licensed under CC BY-SA 2.0")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig0903"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0020#fig0903"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("9.3.")]), _vm._v(" Tweet by Julie DiCaro, December 27, 2016; used with permission.")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig1001"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0021#fig1001"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("10.1.")]), _vm._v(" Debbie Reynolds and Carrie Fisher at the Primetime Creative Arts Emmy Awards in Los Angeles, California, 2011. Photo by WENN")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig1002"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0021#fig1002"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("10.2.")]), _vm._v(" Carrie Fisher attends a celebrity Q&A session at Fan Expo Vancouver in British Columbia, 2015. Photo by Phillip Chin / WireImage")])]), _vm._v(" "), _c('p', {
    staticClass: "tocill",
    attrs: {
      "id": "rfig1003"
    }
  }, [_c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/wsumidejewski0021#fig1003"
    }
  }, [_c('span', {
    staticClass: "ccust1"
  }, [_vm._v("10.3.")]), _vm._v(" "), _c('i', [_vm._v("Star Wars")]), _vm._v(": Journey to "), _c('i', [_vm._v("The Last Jedi")]), _vm._v(" #92 (2017). Topps trading card used courtesy of The Topps Company Inc.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5913bbe8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-midejewski-0008.vue
// module id = 75
// module chunks = 0